import React from 'react';
import { useSetGoalContext } from '../../context/useSetGoalContext';
import { FinancialGoalType } from '../../context/SetGoalProvider';
import { LargePurchase } from './components/LargePurchase/LargePurchase';
import { Expense } from './components/Expense/Expense';

export const Budget = () => {
  const { wizard } = useSetGoalContext();

  if (wizard.goalType === FinancialGoalType.Expense) {
    return <Expense />;
  }

  return <LargePurchase />;
};
